import React, {Component} from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import {media} from "../../../../components/styled"

import "./modal.css";

/**
 * @render react
 * @name Modal
 * @example
 * <Modal isOpen={true} themeColor='#51d7fb' headerTitle="New Year's Day"><p>Hold on to your memories. They will hold on to you.</p></Modal>
 */
class Modal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

        this.handleClose = this.handleClose.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            showModal: nextProps.isOpen
        });
    }

    handleClose() {
        this.props.handleClose();
    }

    render() {
        const {shouldCloseOnOverlayClick, children} = this.props;

        return (
            <ReactModal
                className="modal-content"
                isOpen={this.state.showModal}
                onRequestClose={this.handleClose}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                ariaHideApp={false}
            >
                <CloseIcon onClick={this.handleClose}/>
                <Body>{children}</Body>
            </ReactModal>
        );
    }
}

export default Modal;

const Body = styled.div`
  padding: 54px 24px 54px 54px;
  background:  var(--color-dark-grey);
  color: var(--color-theme);
  border-radius: 12px;
  box-shadow: var(--shadow-modal);
  /* max-height: 500px;
  overflow: auto; */
`;

const CloseIcon = styled.span`
    border: 1px solid #fff;
    border-radius: 50%;
    background-color: #0e1724;
  	display: block;
    height: 24px;
    width: 24px;
    position: absolute;
    top: 40px;
    transform: translateY(-50%);
    right: 16px;
    opacity: 0.8;
    cursor: pointer;
    transition: all .2s ease-in;
    ${media.tablet`width: 34px; height: 34px; top: 0; right: -15px;`}
    
    
    
    &:hover{
       /* background-color: rgba(22, 45, 61, 0.5); */
       opacity: 1;
    }   
    
    &:before,&:after{
      content: '';
      height: 16px;
      width: 2px;
      background: var(--bg-modal-cross);
      position: absolute;
      top: 50%;
      left: 50%;
      border-radius: 6px;
    }
    
    &:before{
    rotate(-45deg);
    transform: translate(-50%,-50%) rotate(-45deg);
    }
    
    &:after{
    rotate(45deg);
    transform: translate(-50%,-50%) rotate(45deg);
    }
}
`;



// WEBPACK FOOTER //
// ./src/components/styled/ui/modal/modal.js